import type { Value } from 'formulascript/interpreter';

import { wrapFunction } from '../utils';

/**
 * Tests if `array` fully intersects with `target`. This means all items in `target` should also be in `array`.
 */
export const INTERSECTS = (
  target: Value[],
  array: Value[],
  mode = 'all',
): boolean => {
  switch (mode) {
    case 'all': {
      return target.every((item) => {
        return array.includes(item);
      });
    }
    case 'any': {
      return target.some((item) => {
        return array.includes(item);
      });
    }
    default: {
      throw new Error(
        "INTERSECTS expects either 'all' or 'any' as the third argument",
      );
    }
  }
};

export default wrapFunction(INTERSECTS, {
  name: 'INTERSECTS',
  nargs: 2,
  types: ['array', 'array', 'string'],
});
